export default __webpack_public_path__ + "static/media/Notice of Annual Shareholders Meeting (Dec 4, 2020).76df887c.pdf";